import { randomUrlSafeString, toBase64Url } from '../api/ids';

export interface PkcePair {
  verifier: string;
  challenge: string;
}

/** SHA-256 of an ASCII string via WebCrypto (`crypto.subtle`). */
export async function sha256Base64Url(input: string): Promise<string> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) throw new Error('WebCrypto (crypto.subtle) is required for PKCE');
  const digest = await subtle.digest('SHA-256', new TextEncoder().encode(input));
  return toBase64Url(digest);
}

/**
 * Generates an RFC 7636 PKCE pair: a 64-character verifier from the unreserved character set and
 * its S256 challenge (`BASE64URL(SHA256(ASCII(verifier)))`).
 */
export async function generatePkce(): Promise<PkcePair> {
  const verifier = randomUrlSafeString(64);
  const challenge = await sha256Base64Url(verifier);
  return { verifier, challenge };
}

/** Random opaque value for `state` / `nonce` parameters. */
export function randomState(): string {
  return randomUrlSafeString(32);
}
